import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LanguageProvider } from "./contexts/LanguageContext";
import { LayoutProvider } from "./contexts/LayoutContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Navbar from "./components/ui/Navbar/Navbar";
import Footer from "./components/ui/Footer/Footer";
import FloatingAiWidget from "./components/ai/FloatingAiWidget";
import ScrollToTop from "./components/ui/ScrollToTop/ScrollToTop";
import RouterScrollToTop from "./components/RouterScrollToTop";
import "./styles/cms.css";
import "./styles/toast.css"; // 
import "./styles/courses.css";
import "./styles/floating-ai-widget.css";

// ✅ API client
import api from "./api/client";

// صفحات رئيسية
import Home from "./pages/Home/Home";

// ✅ صفحات تعريفية / ثابتة
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import CoursesPage from "./pages/CoursesPage";
import CourseDetails from "./pages/CourseDetails";
import MyCourses from "./pages/MyCourses";
import CourseLearn from "./pages/CourseLearn";
import CoursePaymentSuccess from "./pages/CoursePaymentSuccess";
import JobsPage from "./pages/JobsPage";
import JobDetails from "./pages/JobDetails";
import MyJobApplications from "./pages/MyJobApplications";
import FreelancerServicesPage from "./pages/FreelancerServicesPage";
import FreelancerServiceDetails from "./pages/FreelancerServiceDetails";
import FreelancerProfilePage from "./pages/FreelancerProfilePage";
import MyServiceOrders from "./pages/MyServiceOrders";
import ServiceOrderDetails from "./pages/ServiceOrderDetails";
import ServiceOrderWorkspace from "./pages/ServiceOrderWorkspace";
import MyFreelancerOrders from "./pages/MyFreelancerOrders";
import ServicePaymentSuccess from "./pages/ServicePaymentSuccess";
import AiAssistantPage from "./pages/AiAssistantPage";
import ProviderDashboardPage from "./pages/ProviderDashboardPage";

// المتجر
import CourseCheckout from "./pages/CourseCheckout";
import ServiceCheckout from "./pages/ServiceCheckout"; 
// الحساب
import Account from "./components/account/Account";
import MyInvoices from "./components/account/MyInvoices";
import InvoiceDetails from "./components/account/InvoiceDetails";
import MyDownloads from "./screens/account/MyDownloads";
import Notifications from "./components/account/Notifications";

// المدونة
import BlogList from "./components/blog/BlogList";
import BlogDetail from "./components/blog/BlogDetail";

// المفضلة

// تسجيل الدخول
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import VerifyEmail from "./components/auth/VerifyEmail";

// مكوّن داخلي يستخدم الكونتكست
import { useLanguage } from "./contexts/LanguageContext";
import { useLayout } from "./contexts/LayoutContext";
import { resolveFeatureSections } from "./utils/featureSections";

// ✅ Route Guard
import ProtectedRoute from "./components/auth/ProtectedRoute";
import logger from "./utils/logger.js";

function AppInner() {
  const { dir } = useLanguage();
  const { settings } = useLayout();
  const isRTL = dir === 'rtl';
  const sections = resolveFeatureSections(settings);

  return (
    <div className={`app-root app-dir-${dir} d-flex flex-column min-vh-100`}>
       <ThemeProvider>
      <Navbar />

      <main className="flex-grow-1">
       <RouterScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />

          {/* الصفحات الثابتة */}
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route
            path="/courses"
            element={sections.courses ? <CoursesPage /> : <Navigate to="/" replace />}
          />
          <Route path="/courses/success" element={<CoursePaymentSuccess />} />
          <Route
            path="/courses/:courseRef"
            element={sections.courses ? <CourseDetails /> : <Navigate to="/" replace />}
          />
          <Route
            path="/courses/:courseRef/checkout"
            element={
              <ProtectedRoute>
                {sections.courses ? <CourseCheckout /> : <Navigate to="/" replace />}
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={sections.jobs ? <JobsPage /> : <Navigate to="/" replace />}
          />
          <Route
            path="/jobs/:jobRef"
            element={sections.jobs ? <JobDetails /> : <Navigate to="/" replace />}
          />
          <Route
            path="/freelancers"
            element={sections.services ? <FreelancerServicesPage /> : <Navigate to="/" replace />}
          />
          <Route
            path="/freelancers/:serviceRef"
            element={sections.services ? <FreelancerServiceDetails /> : <Navigate to="/" replace />}
          />
          <Route
            path="/freelancers/profile/:freelancerRef"
            element={sections.services ? <FreelancerProfilePage /> : <Navigate to="/" replace />}
          />
          <Route
            path="/freelancers/:serviceRef/checkout"
            element={
              <ProtectedRoute>
                {sections.services ? <ServiceCheckout /> : <Navigate to="/" replace />}
              </ProtectedRoute>
            }
          />
          <Route path="/services/success" element={<ServicePaymentSuccess />} />

          {/* المتجر */}


          {/* السلة */}

          {/* الدفع */}

          {/* نجاح / إلغاء الدفع */}

          {/* الحساب */}
          <Route
            path="/Account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />


          <Route
            path="/my-invoices"
            element={
              <ProtectedRoute>
                <MyInvoices />
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoice/:id"
            element={
              <ProtectedRoute>
                <InvoiceDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-downloads"
            element={
              <ProtectedRoute>
                <MyDownloads />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-courses"
            element={
              <ProtectedRoute>
                <MyCourses />
              </ProtectedRoute>
            }
          />


          <Route
            path="/ai-assistant"
            element={
              sections.aiChat ? (
                <ProtectedRoute>
                  <AiAssistantPage />
                </ProtectedRoute>
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          <Route
            path="/my-job-applications"
            element={
              <ProtectedRoute>
                <MyJobApplications />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-service-orders"
            element={
              <ProtectedRoute>
                <MyServiceOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-service-orders/:orderId"
            element={
              <ProtectedRoute>
                <MyServiceOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-orders/:orderId"
            element={
              <ProtectedRoute>
                <ServiceOrderWorkspace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-orders/:orderId/workspace"
            element={
              <ProtectedRoute>
                <ServiceOrderWorkspace />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-freelancer-orders"
            element={
              <ProtectedRoute>
                <MyFreelancerOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-freelancer-orders/:orderId"
            element={
              <ProtectedRoute>
                <MyFreelancerOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/provider-dashboard"
            element={
              <ProtectedRoute>
                <ProviderDashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/learn/:courseRef"
            element={
              <ProtectedRoute>
                <CourseLearn />
              </ProtectedRoute>
            }
          />

          <Route
            path="/learn/:courseRef/lesson/:lessonId"
            element={
              <ProtectedRoute>
                <CourseLearn />
              </ProtectedRoute>
            }
          />
          <Route path="/account/notifications" element={<Notifications />} />


          {/* تتبع الطلب */}

          {/* المدونة */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />

          {/* المفضلة */}

          {/* العروض */}

          {/* auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Routes>
      </main>
        </ThemeProvider>

      <Footer />
      <FloatingAiWidget />
       <ScrollToTop />
      
      {/* ============================================
          ✅ ToastContainer - نظام الإشعارات الموحد
          ============================================
          
          الإعدادات:
          - position: حسب اتجاه اللغة (RTL = top-left, LTR = top-right)
          - autoClose: 3000ms (3 ثواني) للإشعارات العادية
          - hideProgressBar: false (إظهار شريط التقدم)
          - newestOnTop: true (الجديد فوق)
          - closeOnClick: true (إغلاق بالنقر)
          - rtl: حسب اتجاه اللغة
          - pauseOnFocusLoss: true (إيقاف عند فقدان التركيز)
          - draggable: true (سحب للإغلاق)
          - pauseOnHover: true (إيقاف مؤقت عند المرور)
          - theme: "light" (الثيم الفاتح)
          - limit: 5 (حد أقصى 5 إشعارات)
          - transition: Slide (رسوم متحركة)
          ============================================ */}
      <ToastContainer
        position={isRTL ? 'top-left' : 'top-right'}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={isRTL}
        pauseOnFocusLoss={true}
        draggable={true}
        pauseOnHover={true}
        theme="light"
        limit={5}
        transition={Slide}
        toastStyle={{
          fontSize: '0.85rem',
          maxWidth: '380px',
        }}
        style={{
          top: '80px',
          zIndex: 99999,
        }}
      />
    </div>
  );
}

function App() {
  useEffect(() => {
    const ping = async () => {
      try {
        await api.apiPost("track-visit", {
          page: window.location.href,
        });
      } catch (err) {
        logger.error("Tracking error:", err);
      }
    };

    ping();
    const intervalId = setInterval(ping, 60_000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <LanguageProvider>
      <LayoutProvider>
        <AuthProvider>
          <AppInner />
        </AuthProvider>
      </LayoutProvider>    
    </LanguageProvider>
  );
}

export default App;
